export default {
  metrics: {
    nrr: {
      title: 'NRR % (Trimestral)',
      description:
        '(Receita de subscrição {{currentMonth}} (Q{{currentQuarter}}) + Receita de taxa de serviço {{currentMonth}} (Q{{currentQuarter}})) / (Receita de subscrição {{prevMonth}} (fim de Q{{prevQuarter}}) + Receita de taxa de serviço {{prevMonth}} (fim de Q{{prevQuarter}})) * 100',
    },
    upgrades: 'Melhorias de conta',
    downgrades: 'Reduções de conta',
    gte_c_tier: 'Contas ≥ Grau C',
    churn: 'Churn (suspenso)',
    offers_turned_on: 'Ofertas ativadas',
    flyers_sent: 'Flyers enviados',
    on_google_ads_trial: 'Em avaliação Google Ads',
    converted_google_ads: 'Google Ads convertidos com sucesso',
    first_time_500_monthly_sales: 'Primeiro mês de €500',
    '14_days_no_sales': '14 dias ativo, sem receita',
  },
  details: {
    address: 'Morada',
    subscriptions: 'Subscrições atuais',
    best_sales: 'Melhor mês de sempre',
    sales: 'Vendas de {{month}}',
    tier: 'Tier de {{month}}',
    live_from: 'Data de lançamento',
    owner_phone: 'Telefone do proprietário',
    owner_email: 'Email do proprietário',
    owner: 'Nome do proprietário',
    name: 'Restaurante',
    export_csv: 'Exportar CSV',
  },
  publish: 'Publicar',
  unpublish: 'Despublicar',
};
